export const API_KEY = 'AIzaSyAamVCoyQ4AuvBpxVRMs9P-HFkfPVQj0Kw'



// WEBPACK FOOTER //
// ./src/components/Dashboard/Views/Maps/API_KEY.js